import { useGlobalDIContext } from '@context/GlobalDIContext';
import { CHECK_AUTH, FETCH_AUTH_USER } from '@features/user/config';
import { getServerErrorMessage } from '@g2-shared/common';
import { useQuery } from 'react-query';

interface useCheckAuthInterface {
  isAuthenticated?: boolean;
  isLoading: boolean;
  errorMessage: string;
}

export const useCheckAuth = (): useCheckAuthInterface => {
  const { DirectMoneyApiClient } = useGlobalDIContext();

  const { data, isLoading, error } = useQuery(
    [CHECK_AUTH],
    // @ts-ignore
    async () => {
      try {
        const response = await DirectMoneyApiClient.checkAuth();
        return response.data.result;
      } catch (e: any) {
        console.log('GRESKA!!', e);
      }
    },
    {
      refetchOnReconnect: false,
      retry: false,
      staleTime: 2000,
    }
  );

  return {
    isLoading,
    isAuthenticated: !isLoading && !!data,
    errorMessage: error ? getServerErrorMessage(error) : undefined,
  };
};
